import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { defaultApplication } from '@/utilities/constants';

export const application = {
  namespaced: true,
  state: Object.assign({}, defaultApplication),
  actions,
  getters,
  mutations
};
